import { useEffect } from "react";
import { nameConverter } from "../../services/help";

const MoreFiltersNotFound = ({ name, reset }) => {

    useEffect(() => {
        if (name == 'categories') {
            reset('primarySubjectCategoryId')
        } else {
            reset(name)
        }
    }, [name])

    return <li className="ListNotFound" >{nameConverter(name)} یافت نشد</li>
}

export default MoreFiltersNotFound;